import { useWatch } from 'react-hook-form';

export const useFormData = () => useWatch();

export const useFieldValue = (name: string) => {
  const value = useWatch({ name });
  return value === undefined ? '' : value;
};
